export default "__VITE_ASSET__BjDUmB7l__"